var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPropisiPoPoglavljima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32.045 32.046",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.302,6.499h-2.308v-0.6c0-1.181-0.957-2.138-2.137-2.138h-1.021C19.807,1.675,18.108,0,16.022,0 c-2.086,0-3.785,1.675-3.815,3.761h-1.021c-1.18,0-2.137,0.957-2.137,2.138v0.6H6.742c-0.765,0-1.408,0.618-1.408,1.383v22.78 c0,0.765,0.643,1.384,1.408,1.384h18.561c0.766,0,1.408-0.619,1.408-1.384V7.881C26.71,7.117,26.067,6.499,25.302,6.499z M16.022,1.999c0.984,0,1.788,0.785,1.817,1.762h-3.634C14.235,2.784,15.038,1.999,16.022,1.999z M24.95,30.35H7.094V8.192h1.955 v1.564h13.945V8.192h1.955V30.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.476,12.69h-4.495c-0.707,0-1.283,0.527-1.283,1.236s0.576,1.238,1.283,1.238h4.495c0.708,0,1.282-0.529,1.282-1.238 S23.184,12.69,22.476,12.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.481,13.864l-0.965-0.752c-0.238-0.187-0.58-0.156-0.782,0.068l-0.556,0.616c-0.106,0.118-0.159,0.275-0.146,0.435 c0.014,0.159,0.092,0.305,0.217,0.403l1.683,1.328c0.406,0.321,0.988,0.287,1.354-0.079l2.949-2.949 c0.143-0.143,0.223-0.336,0.223-0.538s-0.08-0.396-0.223-0.538l-0.337-0.337c-0.297-0.297-0.778-0.297-1.075,0L11.481,13.864z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.476,18.424h-4.495c-0.707,0-1.283,0.529-1.283,1.238c0,0.707,0.576,1.238,1.283,1.238h4.495 c0.708,0,1.282-0.531,1.282-1.238C23.758,18.954,23.184,18.424,22.476,18.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.481,19.598l-0.965-0.752c-0.238-0.186-0.58-0.154-0.782,0.069l-0.556,0.616c-0.106,0.117-0.159,0.275-0.146,0.435 c0.014,0.158,0.092,0.306,0.217,0.403l1.683,1.328c0.407,0.32,0.989,0.285,1.355-0.08l2.95-2.949 c0.143-0.143,0.223-0.336,0.223-0.538c0-0.2-0.08-0.396-0.223-0.538L14.9,17.255c-0.297-0.297-0.778-0.297-1.075,0L11.481,19.598z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.476,23.963h-4.495c-0.707,0-1.283,0.529-1.283,1.238s0.576,1.238,1.283,1.238h4.495c0.708,0,1.282-0.529,1.282-1.238 S23.184,23.963,22.476,23.963z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.481,25.137l-0.965-0.752c-0.238-0.188-0.58-0.156-0.782,0.068l-0.556,0.615c-0.106,0.119-0.16,0.275-0.146,0.436 c0.013,0.159,0.092,0.305,0.217,0.402l1.683,1.33c0.407,0.32,0.989,0.285,1.355-0.08l2.95-2.95c0.297-0.298,0.297-0.776,0-1.075 L14.9,22.794c-0.143-0.144-0.336-0.224-0.538-0.224s-0.395,0.08-0.538,0.224L11.481,25.137z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropisiPoPoglavljima);
export default __webpack_public_path__ + "static/media/PropisiPoPoglavljima.54ef50f1de683d4677db78ee58054a6b.svg";
export { ForwardRef as ReactComponent };